import { render, staticRenderFns } from "./NewTrendyolChannel.vue?vue&type=template&id=10460c12"
import script from "./NewTrendyolChannel.vue?vue&type=script&lang=js"
export * from "./NewTrendyolChannel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports